import { Phone, MapPin, Clock, Check } from "lucide-react";
import { Card, CardContent } from "./ui/card";
import { Button } from "./ui/button";

const Features = () => {
  const features = [
    {
      icon: Check,
      title: "Consistent Quality",
      description: "Same perfect taste every single time"
    },
    {
      icon: Check,
      title: "Fair Price",
      description: "Premium biryani at just ₱149"
    },
    {
      icon: Check,
      title: "Quick Service",
      description: "Order and get it delivered fast"
    },
    {
      icon: Check,
      title: "Authentic Recipe",
      description: "Traditional Bawarchi-style preparation"
    }
  ];

  const contactInfo = [
    {
      icon: Phone,
      title: "Order by WhatsApp for pre and bulk orders",
      link: "https://wa.me/639953947586",
      linkText: "+63 995 394 7586"
    },
    {
      icon: MapPin,
      title: "Serving Makati",
      description: "Fast delivery throughout Makati City area"
    },
    {
      icon: Clock,
      title: "Made Fresh Daily",
      description: "Every order prepared with authentic spices and quality ingredients"
    }
  ];

  return (
    <section className="py-20 bg-muted/30">
      <div className="container">
        <div className="grid md:grid-cols-3 gap-6 mb-16">
          {contactInfo.map((item, index) => (
            <Card key={index} className="border-2 hover:border-primary transition-colors duration-300">
              <CardContent className="p-6 text-center">
                <item.icon className="h-12 w-12 mx-auto mb-4 text-primary" />
                <h3 className="text-xl font-bold text-foreground mb-2">{item.title}</h3>
                {item.link ? (
                  <Button variant="link" asChild className="text-lg p-0 h-auto">
                    <a href={item.link} target="_blank" rel="noopener noreferrer">
                      {item.linkText}
                    </a>
                  </Button>
                ) : (
                  <p className="text-muted-foreground">{item.description}</p>
                )}
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-foreground mb-4">Why Bawarchi 149?</h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => (
            <div key={index} className="flex items-start gap-4 p-6 bg-card rounded-xl border hover:shadow-lg transition-shadow duration-300">
              <feature.icon className="h-6 w-6 text-primary mt-1 flex-shrink-0" />
              <div>
                <h3 className="font-bold text-foreground mb-1">{feature.title}</h3>
                <p className="text-sm text-muted-foreground">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
